export default {"src":"https://fishbrain.com/_next/static/media/louisiana.2d88d416.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};